import { IPopup } from '../interface/IPopup';

export class Popup implements IPopup {

  id: number;
  imagen: string;
  nuevaImagen?: any;
  activo: string;
  fechaInicio: string;
  horaInicio: string;
  fechaFin: string;
  horaFin: string;
  fecCreacion?: Date;
  fecModificacion?: Date;
  modificado?: boolean;
  esNuevo?: boolean;

  constructor(popup: IPopup) {
    this.id = popup.id;
    this.imagen = popup.imagen;
    this.nuevaImagen = popup.nuevaImagen;
    this.activo = popup.activo;
    this.fechaInicio = popup.fechaInicio;
    this.horaInicio = popup.horaInicio;
    this.fechaFin = popup.fechaFin;
    this.horaFin = popup.horaFin;
    this.fecCreacion = popup.fecCreacion;
    this.fecModificacion = popup.fecModificacion;
    this.modificado = popup.modificado;
    this.esNuevo = popup.esNuevo;
  }

  getFormData(): FormData {
    const formData = new FormData();
    formData.append('activo', this.activo.toString());
    if (this.fechaInicio) {
      formData.append('fechaInicio', this.fechaInicio);
    }
    if (this.horaInicio) {
      formData.append('horaInicio', this.horaInicio);
    }
    if (this.fechaFin) {
      formData.append('fechaFin', this.fechaFin);
    }
    if (this.horaFin) {
      formData.append('horaFin', this.horaFin);
    }
    if (typeof this.nuevaImagen !== 'undefined') {
      formData.append('file_upload', this.nuevaImagen, this.nuevaImagen.name);
    }

    return formData;
  }

}



// WEBPACK FOOTER //
// /app/src/model/class/Popup.ts